import React, { FunctionComponent, useEffect, Fragment } from "react";
import * as hljs from "highlight.js";
import { Helmet } from "react-helmet";

export const CodeSyntaxHighlight: FunctionComponent = () => {
  useEffect(() =>{
    updateCodeSyntaxHighlighting();
  });

  const updateCodeSyntaxHighlighting = () =>{
    document.querySelectorAll("pre code").forEach(block =>{
      hljs.highlightBlock(block as HTMLElement);
    });
  }

  return (
    <Helmet>
      <link rel="stylesheet" href="/styles/vs2015.css" />
    </Helmet>
  );
}